import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import './style.css';
import Layout from '../../components/Layout/AdminLayout/AdminLayout';
import {
    MemberTabDetails, ResponseMemberTabDetails, RequestMembersRegistryFirstTabUpdate, MembersRegistryError,
    RequestMembersRegistrySecondTab, RequestMembersRegistryThirdTab,
    ResultDeparment, ResultCivilStatus
} from '../../interface/IMembersRegistry';
import { ApiResponse } from '../../interface/IResponse';
import membersRegistryService from './membersRegistryService';
import SuccessModal from '../../components/Modal/SuccessModal';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import helpers from '../../helpers/index';

function UpdateMember() {

    const navigate = useNavigate();
    const memberId = useParams<{ memberId: string; }>();


    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

    const [activeSections, setActiveSections] = useState({
        basicInfo: true,
        otherInfo: false,
        workInfo: false
    });

    const defaultMemberTabDetails: MemberTabDetails = {
        membershipId: '', departmentId: 0, firstname: '', middlename: '', lastname: '', taxIDNo: '',
        username: '', email: '', contactNo: '', address: '', dateOfBirth: null, age: '', gender: '',
        civilStatus: 0, educationalAttainment: '', religion: '', occupation: '', annualIncome: '',
        numberOfDependents: '', dateAccepted: null, dateOfSeparation: null, bodResNo: '',
        membershipType: '', amountSubscribe: '', initialPaidAmount: ''
    };

    const [memberTabDetails, setMemberTabDetails] = useState<MemberTabDetails>(defaultMemberTabDetails);
    const [memberRegistryError, setMemberRegistryError] = useState<MembersRegistryError>({});


    const [departmentSelectData, setDepartmentSelectData] = useState<SelectData[]>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<SelectData>();
    const [civilStatusList, setCivilStatusList] = useState<ResultCivilStatus[]>([]);

    interface SelectData {
        label: string;
        value: number;
    }

    const errMessage = "This parameter is required";


    function getPermission() {
        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }


    const toggleSection = (section: keyof typeof activeSections) => {
        setActiveSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };


    function validateTab1(): boolean {
        var errors: MembersRegistryError = {};
        if (!memberTabDetails.departmentId) errors.department = errMessage;
        if (!memberTabDetails.firstname) errors.firstname = errMessage;
        if (!memberTabDetails.lastname) errors.lastname = errMessage;
        if (!memberTabDetails.email) errors.email = errMessage;
        if (!memberTabDetails.contactNo) errors.contactNo = errMessage;

        setMemberRegistryError(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    }

    function validateTab2(): boolean {
        var errors: MembersRegistryError = {};
        if (!memberTabDetails.address) errors.address = errMessage;
        if (!memberTabDetails.dateOfBirth) errors.dateOfBirth = errMessage;
        if (!memberTabDetails.age) errors.age = errMessage;
        if (!memberTabDetails.gender) errors.gender = errMessage;
        if (!memberTabDetails.civilStatus) errors.civilStatus = errMessage;
        if (!memberTabDetails.educationalAttainment) errors.educationalAttainment = errMessage;
        if (!memberTabDetails.religion) errors.religion = errMessage;
        if (!memberTabDetails.bodResNo) errors.bodResNo = errMessage;

        setMemberRegistryError(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    }

    function validateTab3(): boolean {
        var errors: MembersRegistryError = {};
        if (!memberTabDetails.occupation) errors.occupation = errMessage;
        if (!memberTabDetails.annualIncome) errors.annualIncome = errMessage;
        if (!memberTabDetails.numberOfDependents) errors.numberOfDependents = errMessage;
        if (!memberTabDetails.dateAccepted) errors.dateAccepted = errMessage;
        // if (!memberTabDetails.bodResNoTermination) errors.bodResNoTermination = errMessage;
        if (!memberTabDetails.membershipType) errors.membershipType = errMessage;

        setMemberRegistryError(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    }




    async function getMemberTabDetails() {
        try {
            var response: AxiosResponse<ResponseMemberTabDetails> = await membersRegistryService.getMemberDetailsTab(Number(memberId.memberId));
            var details = response.data.result;
            setMemberTabDetails(details);
            await getDepartmentsList(Number(details.departmentId));
        } catch (err) {
            throw err;
        }
    }

    async function getDepartmentsList(selectedDepartmentId: number) {
        try {
            var response = await membersRegistryService.listDepartments();
            const newSelectData: SelectData[] = [];

            response.data.result.forEach((department: ResultDeparment) => {
                var departmentData: SelectData = {
                    value: department.departmentId,
                    label: department.departmentName
                }
                newSelectData.push(departmentData);
                if (selectedDepartmentId == departmentData.value) {
                    setSelectedDepartment(departmentData);
                }
            });
            setDepartmentSelectData(newSelectData);
        } catch (err) {
            console.log('err:: ', err);
        }
    }

    async function loadCivilStatusList() {
        try {
            var axiosResponse = await membersRegistryService.getCivilStatusList();
            setCivilStatusList(axiosResponse.data.result);
        } catch (err) {
            console.log('SetCivilStatusList:: ', err);
        }
    }



    async function handleFullUpdate() {

        setMemberRegistryError({});


        const isTab1Valid = validateTab1();
        const isTab2Valid = validateTab2();
        const isTab3Valid = validateTab3();


        if (!isTab1Valid || !isTab2Valid || !isTab3Valid) {
            setActiveSections({
                basicInfo: !isTab1Valid || activeSections.basicInfo,
                otherInfo: !isTab2Valid || activeSections.otherInfo,
                workInfo: !isTab3Valid || activeSections.workInfo
            });
            return;
        }

        try {
            document.querySelector('.loader-container')?.classList.add('loader');

            var firstTabInput: RequestMembersRegistryFirstTabUpdate = {
                departmentId: memberTabDetails.departmentId,
                firstname: memberTabDetails.firstname,
                middlename: memberTabDetails.middlename,
                lastname: memberTabDetails.lastname,
                taxIdNo: memberTabDetails.taxIDNo,
                email: memberTabDetails.email,
                contactNo: memberTabDetails.contactNo
            };
            await membersRegistryService.updateTab1NoPassword(Number(memberId.memberId), firstTabInput);


            var secondTabInput: RequestMembersRegistrySecondTab = {
                address: memberTabDetails.address,
                dateOfBirth: memberTabDetails.dateOfBirth,
                age: memberTabDetails.age,
                gender: memberTabDetails.gender,
                civilStatus: memberTabDetails.civilStatus,
                educationalAttainment: memberTabDetails.educationalAttainment,
                religion: memberTabDetails.religion,
                bodResNo: memberTabDetails.bodResNo
            };
            await membersRegistryService.updateMembersSecondTab(Number(memberId.memberId), secondTabInput);


            var thirdTabInput: RequestMembersRegistryThirdTab = {
                occupation: memberTabDetails.occupation,
                annualIncome: memberTabDetails.annualIncome,
                numberOfDependents: memberTabDetails.numberOfDependents,
                dateAccepted: memberTabDetails.dateAccepted,
                dateOfSeparation: memberTabDetails.dateOfSeparation,
                bodResNoTermination: memberTabDetails.bodResNoTermination,
                membershipType: memberTabDetails.membershipType,
                amountSubscribe: memberTabDetails.amountSubscribe,
                initialPaidAmount: memberTabDetails.initialPaidAmount
            };
            await membersRegistryService.updateMembersThirdTab(Number(memberId.memberId), thirdTabInput);


            setIsSuccessModalOpen(true);

        } catch (error) {
            console.log('Update Failed:', error);

        } finally {
            document.querySelector('.loader-container')?.classList.remove('loader');
        }
    }



    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setMemberTabDetails(prev => ({
            ...prev,
            [name]: value
        }));
    };


    function dateChange(name: string, date: Date | null) {
        setMemberTabDetails(prev => ({ ...prev, [name]: date }));
    }

    function onClose() {
        setIsSuccessModalOpen(false);
        navigate('/Admin/MembersRegistry');
    }

    useEffect(() => {
        (async () => {
            document.querySelector('.loader-container')?.classList.add('loader');
            await loadCivilStatusList();
            await getMemberTabDetails();
            getPermission();
            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>
            <SuccessModal message='Member updated successfully' isOpen={isSuccessModalOpen} onClose={onClose} />

            <div className="title-container">
                <div className="dv-title">
                    <h1>Update Member</h1>
                </div>
                <div className="title-btn-container vertical-flex-bottom">
                    <button type="button" onClick={() => navigate('/Admin/MembersRegistry')} className="btn-white-green-2 center-middle">
                        Cancel
                    </button>
                    <button type="button" disabled={isReadOnly} onClick={handleFullUpdate} className="btn-green-2 center-middle">
                        Update All
                    </button>
                </div>
            </div>

            <br />

            <div className='content-container update-member'>
                <div className='padding-container'>

                    {/* Header Info */}
                    <div style={{ marginBottom: '20px' }}>
                        <label className="label-2">Membership Id:</label> <label className="label-3">#{memberTabDetails.membershipId}</label>
                        <br /><br />
                        <span >
                            <label className="label-2">Username:</label> <label className="label-3">{memberTabDetails.username}</label>
                        </span>
                    </div>


                    <div className="accordion-item">
                        <div className={`accordion-header ${activeSections.basicInfo ? 'active' : ''}`} onClick={() => toggleSection('basicInfo')}>
                            <span>Basic Information</span>

                        </div>
                        <div className={`accordion-body ${activeSections.basicInfo ? 'open' : ''}`}>

                            {/* Department */}
                            <div className='label-1'>Department:</div>
                            <Select
                                className={memberRegistryError?.department ? "textbox-red-2 " : "textbox-green-2 select"}
                                isDisabled={isReadOnly}
                                value={selectedDepartment}
                                options={departmentSelectData}
                                onChange={(opt) => {
                                    setMemberTabDetails(prev => ({ ...prev, departmentId: Number(opt?.value) }));
                                    setSelectedDepartment({ value: Number(opt?.value), label: String(opt?.label) });
                                }}
                            />
                            <label className='label-error-1'>{memberRegistryError?.department}</label>

                            {/* First Name */}
                            <div className='label-1'>First Name:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.firstname ? "textbox-red-2" : "textbox-green-2"}
                                name="firstname" placeholder="Enter First Name" value={memberTabDetails.firstname} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError?.firstname}</label>

                            {/* Middle Name */}
                            <div className='label-1'>Middle Name:</div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2"
                                name="middlename" placeholder="Enter Middle Name" value={memberTabDetails.middlename} onChange={handleChange} />
                            <br /><br />
                            {/* Last Name */}
                            <div className='label-1'>Last Name:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.lastname ? "textbox-red-2" : "textbox-green-2"}
                                name="lastname" placeholder="Enter Last Name" value={memberTabDetails.lastname} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.lastname}</label>

                            {/* Tax ID */}
                            <div className='label-1'>Tax ID No:</div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2"
                                name="taxIDNo" placeholder="Enter Tax ID No." value={memberTabDetails.taxIDNo} onChange={handleChange} />
                            <br /><br />
                            {/* Email */}
                            <div className='label-1'>Email:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.email ? "textbox-red-2" : "textbox-green-2"}
                                name="email" placeholder="eg. koopmember@koop.com" value={memberTabDetails.email} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.email}</label>

                            {/* Contact No */}
                            <div className='label-1'>Contact No:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.contactNo ? "textbox-red-2" : "textbox-green-2"}
                                name="contactNo" placeholder="Enter Contact No." value={memberTabDetails.contactNo} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.contactNo}</label>
                        </div>
                    </div>

                    <br />
                    <div className="accordion-item">
                        <div className={`accordion-header ${activeSections.otherInfo ? 'active' : ''}`} onClick={() => toggleSection('otherInfo')}>
                            <span>Other Information</span>

                        </div>
                        <div className={`accordion-body ${activeSections.otherInfo ? 'open' : ''}`}>

                            <div className='label-1'>Address</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.address ? "textbox-red-2" : "textbox-green-2"}
                                name="address" placeholder="Enter Address" value={memberTabDetails.address} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.address}</label>

                            <div className='label-1'>Date of Birth</div>
                            <DatePicker disabled={isReadOnly} className={memberRegistryError.dateOfBirth ? "textbox-red-2" : "textbox-green-2"}
                                selected={memberTabDetails.dateOfBirth} onChange={(date) => dateChange('dateOfBirth', date)} />
                            <label className='label-error-1'>{memberRegistryError.dateOfBirth}</label>

                            <div className='label-1'>Age</div>
                            {/* Note: Ideally Age is calculated from DOB, but keeping manual input as per your code */}
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.age ? "textbox-red-2" : "textbox-green-2"}
                                name="age" value={memberTabDetails.age} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.age}</label>

                            <div className='label-1'>Gender</div>
                            <select disabled={isReadOnly} className={memberRegistryError.gender ? "textbox-red-2" : "textbox-green-2"}
                                name="gender" value={memberTabDetails.gender?.toLowerCase() ?? ""} onChange={handleChange}>
                                <option value=""></option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                            <label className='label-error-1'>{memberRegistryError.gender}</label>

                            <div className='label-1'>Civil Status</div>
                            <select className={memberRegistryError.civilStatus ? "textbox-red-2" : "textbox-green-2"}
                                name="civilStatus" value={memberTabDetails.civilStatus} disabled={isReadOnly} onChange={handleChange}>
                                <option value=""></option>
                                {civilStatusList.map((item) => (
                                    <option key={item.value} value={item.value}>{item.displayName}</option>
                                ))}
                            </select>
                            <label className='label-error-1'>{memberRegistryError.civilStatus}</label>

                            <div className='label-1'>Educational Attainment</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.educationalAttainment ? "textbox-red-2" : "textbox-green-2"}
                                name="educationalAttainment" placeholder="Educational Attainment" value={memberTabDetails.educationalAttainment} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.educationalAttainment}</label>

                            <div className='label-1'>Religion</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.religion ? "textbox-red-2" : "textbox-green-2"}
                                name="religion" placeholder="Enter Religion" value={memberTabDetails.religion} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.religion}</label>

                            <div className='label-1'>BOD Res. No.:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.bodResNo ? "textbox-red-2" : "textbox-green-2"}
                                name="bodResNo" placeholder="Enter BOD Res No" value={memberTabDetails.bodResNo} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.bodResNo}</label>
                        </div>
                    </div>

                    <br />
                    <div className="accordion-item">
                        <div className={`accordion-header ${activeSections.workInfo ? 'active' : ''}`} onClick={() => toggleSection('workInfo')}>
                            <span>Work & Membership Info</span>

                        </div>
                        <div className={`accordion-body ${activeSections.workInfo ? 'open' : ''}`}>

                            <div className='label-1'>Occupation</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.occupation ? "textbox-red-2" : "textbox-green-2"}
                                name="occupation" placeholder="Enter Occupation" value={memberTabDetails.occupation} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.occupation}</label>

                            <div className='label-1'>Annual Income</div>
                            <input disabled={isReadOnly} type="number" className={memberRegistryError.annualIncome ? "textbox-red-2" : "textbox-green-2"}
                                name="annualIncome" placeholder="Enter Annual Income" value={memberTabDetails.annualIncome} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.annualIncome}</label>

                            <div className='label-1'>Number of Dependents</div>
                            <input disabled={isReadOnly} type="number" className={memberRegistryError.numberOfDependents ? "textbox-red-2" : "textbox-green-2"}
                                name="numberOfDependents" placeholder="Enter Number of Dependents" value={memberTabDetails.numberOfDependents} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.numberOfDependents}</label>

                            <div className='label-1'>Date Accepted</div>
                            <DatePicker disabled={isReadOnly} className={memberRegistryError.dateAccepted ? "textbox-red-2" : "textbox-green-2"}
                                selected={memberTabDetails.dateAccepted} onChange={(date) => dateChange('dateAccepted', date)} />
                            <label className='label-error-1'>{memberRegistryError.dateAccepted}</label>

                            <div className='label-1'>Date of Separation</div>
                            <DatePicker disabled={isReadOnly} className="textbox-green-2"
                                selected={memberTabDetails.dateOfSeparation} onChange={(date) => dateChange('dateOfSeparation', date)} />
                            <br /><br />
                           

                            <div className='label-1'>Membership Type:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.membershipType ? "textbox-red-2" : "textbox-green-2"}
                                name="membershipType" placeholder="Enter Membership Type" value={memberTabDetails.membershipType} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.membershipType}</label>

                            <div className='label-1'>Amount Subscribed</div>
                            <input disabled={isReadOnly} type="number" className={memberRegistryError.amountSubscribe ? "textbox-red-2" : "textbox-green-2"}
                                name="amountSubscribe" placeholder="Enter Amount Subscribed" value={memberTabDetails.amountSubscribe} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.amountSubscribe}</label>

                            <div className='label-1'>Capital Shares</div>
                            <input disabled={isReadOnly} type="number" className="textbox-green-2"
                                name="initialPaidAmount" placeholder="Enter Capital Shares" value={memberTabDetails.initialPaidAmount} onChange={handleChange} />
                            <br />
                            <br />
                            <div className='label-1'>Termination BOD Res. No.:</div>
                            <input disabled={isReadOnly} type="text" className={memberRegistryError.bodResNoTermination ? "textbox-red-2" : "textbox-green-2"}
                                name="bodResNoTermination" placeholder="Enter Termination BOD Res No" value={memberTabDetails.bodResNoTermination} onChange={handleChange} />
                            <label className='label-error-1'>{memberRegistryError.bodResNoTermination}</label>
                        </div>
                    </div>

                    <br />
                    <div className="title-btn-container btn-mobile">
                        <button type="button" onClick={() => navigate('/Admin/MembersRegistry')} className="btn-white-green-2 center-middle">
                            Cancel
                        </button>
                        <button type="button" disabled={isReadOnly} onClick={handleFullUpdate} className="btn-green-2 center-middle">
                            Update All
                        </button>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

export default UpdateMember;